// @flow

import React from 'react';
import type { Node } from 'react';
import type { CmsLayoutProps } from 'shared_components/cms/types';
import { LayoutDefault } from 'shared_components/layouts/Default';
import { renderCmsModule } from 'shared_components/cms/utils';
import { CmsContainer } from 'shared_components/cms/Container';
import { CmsHeadContentRenderer } from 'shared_components/cms/HeadContentRenderer';

/**
 * CmsLayoutDefault
 *
 * @param {CmsLayoutProps} props
 * @returns {Node}
 */
export const CmsLayoutDefault = ({ placeholders }: CmsLayoutProps): Node => {
  const renderPlaceholderModule = renderCmsModule(placeholders);

  return (
    <LayoutDefault scrollTopOnPathChange>
      <CmsHeadContentRenderer
        placeholderName="cmsHeadContent"
        moduleLoader={renderPlaceholderModule}
      />
      <CmsContainer>{renderPlaceholderModule('cmsContent')}</CmsContainer>
    </LayoutDefault>
  );
};
